import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { ClassType } from './class-type.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
@Injectable()
export class ClassTypeService extends AbstractEntityService {

    protected resourceUrl = 'api/class-types';
    private resourceSearchUrl = 'api/_search/class-types';
    protected resourceCountUrl = 'api/_search/count/class-types';

    constructor(protected http: HttpClient) { super(http); }

    create(classType: ClassType): Observable<ClassType> {
        let copy: ClassType = Object.assign({}, classType);
        return this.http.post<ClassType>(this.resourceUrl, copy).map((res: ClassType) => {
            return res;
        });
    }

    update(classType: ClassType): Observable<ClassType> {
        let copy: ClassType = Object.assign({}, classType);
        return this.http.put<ClassType>(this.resourceUrl, copy).map((res: ClassType) => {
            return res;
        });
    }

    find(id: number): Observable<ClassType> {
        return this.http.get<ClassType>(`${this.resourceUrl}/${id}`).map((res: ClassType) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<ClassType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<ClassType[]>>(this.resourceUrl, options);
    }

    search(req?: any): Observable<HttpResponse<ClassType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<ClassType[]>>(this.resourceSearchUrl, options);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type.service.ts